import { useQuery } from '@tanstack/react-query'

import { useGlobalState } from './useGlobalState'

/**
 * The delivery-mode catalog, shared by the picker, the swap dialog, the swap's own demotion
 * and the read-only screen. Held rather than refetched: it is CMDB config, so it changes
 * when someone edits Mongo, not while an expert is editing a module. With the default
 * `staleTime: 0` every window focus refetched it and flipped `isFetching` on all four
 * observers, re-rendering both step tables with it.
 *
 * `staleTime` only holds successful data, so a catalog that failed to load is still retried
 * when a new observer mounts — which is what the swap's block on an unresolvable demotion
 * and the section's "Reload the page to try again" both rest on.
 *
 * One place for the key and the fetch, so the four callers cannot drift apart on either.
 */
export function usePresentationStyles() {
  const { api } = useGlobalState()

  return useQuery({
    queryKey: ['presentationStyles'],
    queryFn: () => api.getPresentationStyles(),
    staleTime: Infinity,
  })
}
